import { ProgressBar } from "primereact/progressbar";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";
import { toast } from "react-toastify";

import iconDownload from "../../../assets/img/interna/download.png";
import {
  CertificadoFProgramaEspecializacionNotas,
} from "../../../services/CertificadosServices";
import { ObtenerEncuestaPersonaPrograma } from "../../../services/CursoService";
import { ObtenerCertificadoPersonaPrograma } from "../../../services/UsuarioService";
import EncuastaPrograma from "../../components/CardEncuentasPrograma/EncuestaPrograma";
import useAlumno from "../../../hooks/useAlumno";
import { PrivateRoutes } from "../../../routes/routes";
import { handleDownloadCertificado, urlToShare } from "../../../helpers/helpers";
import * as constantes from "../../../constants/constantes.js";

function CardBienvenidaProgramaComponent({
  Persona,
  programa,
  listaProgresoLeccionUnidadeCursoPrograma,
  listaLeccionUnidadeCursoPrograma,
  listaEvaluacionesUnidadeCursoPrograma,
  listaUnidadeCursoPrograma,
  listaCursoPrograma,
  setspinnerCertificado,
  spinnerCertificado,
  ProgressSpinner,
  setspinnerNotas,
  spinnerNotas,
  PersonaProgamaData
}) {
  const navigate = useNavigate();
  const { idCurso } = useParams();
  const { configuraciones } = useAlumno();
  
  const [ProgresoPrograma, setProgresoPrograma] = useState(0);
  const [mostrarEncuestas, setmostrarEncuestas] = useState(false);
  const [idEncuestas, setidEncuestas] = useState(0);
  const [isButtonDisabledCertificado, setButtonDisabledCertificado] = useState(false);
  const [isButtonDisabledNotas, setButtonDisabledNotas] = useState(false);

  const { progresoTotal, mensajeProgreso } = useMemo(() => {
    if (!listaProgresoLeccionUnidadeCursoPrograma || !listaLeccionUnidadeCursoPrograma) {
      return { progresoTotal: 0, mensajeProgreso: "Has avanzado el 0% del programa ¡Sigue así!" };
    }

    // Calcular promedio de lecciones
    const sumLecciones = listaProgresoLeccionUnidadeCursoPrograma.reduce(
      (acc, item) => acc + item.PorcentajeAvance, 
      0
    );
    const promedioLecciones = sumLecciones / listaLeccionUnidadeCursoPrograma.length / 2;

    // Calcular progreso de evaluaciones
    const evaluacionesPrimeraVez = listaEvaluacionesUnidadeCursoPrograma?.filter(x => x.intento === 1) || [];
    const progresoEvaluaciones = (evaluacionesPrimeraVez.length * 100) / listaUnidadeCursoPrograma.length / 2;

    const total = promedioLecciones + progresoEvaluaciones;
    
    return {
      progresoTotal: total,
      mensajeProgreso: `Has avanzado el ${total.toFixed()}% del programa ¡Sigue así!`
    };
  }, [
    listaProgresoLeccionUnidadeCursoPrograma, 
    listaLeccionUnidadeCursoPrograma,
    listaEvaluacionesUnidadeCursoPrograma,
    listaUnidadeCursoPrograma
  ]);

  useEffect(() => {
    setProgresoPrograma(progresoTotal);

    // Verificar encuestas
    if (!listaCursoPrograma?.[0]?.idPersonaPrograma) return;

    const jwt = window.localStorage.getItem("jwt");
    const id = listaCursoPrograma[0].idPersonaPrograma;

    // Primera encuesta (al 50% del progreso)
    if (progresoTotal >= 50 && progresoTotal < 100) {
      console.log('sadasd');
      
      ObtenerEncuestaPersonaPrograma({ jwt, id }).then((data) => {
        if (data.length === 0) {
          setmostrarEncuestas(true);
          setidEncuestas(1);
        }
      });
    }

    // Segunda encuesta (al 50% de evaluaciones)
    const evaluacionesPrimeraVez = listaEvaluacionesUnidadeCursoPrograma?.filter(x => x.intento === 1) || [];
    const progresoEvaluaciones = (evaluacionesPrimeraVez.length * 100) / listaUnidadeCursoPrograma.length / 2;
    
    if (progresoEvaluaciones >= 50) {
      ObtenerEncuestaPersonaPrograma({ jwt, id }).then((data) => {
        if (data.length > 0 && !data[0].segundaEncuestaProgramaRealizada) {
          setmostrarEncuestas(true);
          setidEncuestas(2);
        } else if (data.length === 0) {
          setmostrarEncuestas(true);
          setidEncuestas(1);
        }
      });
    }
  }, [progresoTotal, listaCursoPrograma, listaEvaluacionesUnidadeCursoPrograma, listaUnidadeCursoPrograma]);


  const calcularPromedioNotasPorUnidad = useCallback((idCurso) => {
    if (!listaEvaluacionesUnidadeCursoPrograma || !listaUnidadeCursoPrograma) return 0;

    const unidades = listaUnidadeCursoPrograma.filter(x => x.idCurso === idCurso);
    let promedioTotal = 0;

    unidades.forEach(unidad => {
      const evaluaciones = listaEvaluacionesUnidadeCursoPrograma.filter(
        x => x.idUnidad === unidad.idUnidad
      );
      
      if (evaluaciones.length > 0) {
        const notaMasAlta = Math.max(...evaluaciones.map(e => e.nota));
        promedioTotal += notaMasAlta;
      }
    });

    return unidades.length > 0 ? (promedioTotal / unidades.length).toFixed(2) : 0;
  }, [listaEvaluacionesUnidadeCursoPrograma, listaUnidadeCursoPrograma]);


  const programaAprobado = useMemo(() => {
    if (!listaCursoPrograma || !configuraciones) return false;

    const notaMinima = parseFloat(configuraciones.find(z => z.codigo === "NOTA_MINIMA_APROB")?.valor || 0);
    let promedioTotal = 0;
    let todosAprobados = true;

    listaCursoPrograma.forEach(curso => {
      if (curso.idEstado !== 1 || curso.idCondicion === 2) {
        todosAprobados = false;
      }
      promedioTotal += parseFloat(calcularPromedioNotasPorUnidad(curso.idCurso));
    });

    return todosAprobados && promedioTotal >= notaMinima;
  }, [listaCursoPrograma, configuraciones, calcularPromedioNotasPorUnidad]);

  const onDownloadCertificadoPrograma = useCallback(async () => {
    try {
      navigate(`/${PrivateRoutes.HOME}/ShareCertificate/Program/${PersonaProgamaData.idPrograma}/${PersonaProgamaData.idPersonaPrograma}/${idCurso}`, {
        state: { downloading: true }
      });

      const res = await handleDownloadCertificado({
        cursoPersona: PersonaProgamaData,
        listaCursoPrograma: listaCursoPrograma,
        programa: programa,
        persona: Persona,
        tipo: "Program"
      });

      navigate(`/${PrivateRoutes.HOME}/ShareCertificate/Program/${PersonaProgamaData.idPrograma}/${PersonaProgamaData.idPersonaPrograma}/${idCurso}`, {
        state: { downloading: false, res }
      });
    } catch (error) {
      toast.error(error, { autoClose: 3000 });
    }
  }, [PersonaProgamaData, listaCursoPrograma, programa, Persona, idCurso, navigate]);

  const handleDownloadNotasPrograma = useCallback(async () => {
    const jwt = window.localStorage.getItem("jwt");
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getMonth() + 1).padStart(2, '0')}_${String(currentDate.getFullYear()).slice(-2)}`;
    const IDPersonaPrograma = listaCursoPrograma[0].idPersonaPrograma;

    try {
      const dataCert = await ObtenerCertificadoPersonaPrograma({ jwt, IDPersonaPrograma });
      
      const nombrealumno = `${Persona.nombres?.trim() || ''} ${Persona.primerApellido?.trim() || ''} ${Persona.segundoApellido?.trim() || ''}`.trim();
      const nombrecursoprograma = programa.nombre;
      const ubicacion = "Lima";
      const codigoSinPrefijo = dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim();
      const fileName = `${Persona.primerApellido.trim()}-${formattedDate.trim()}-DN_${codigoSinPrefijo}`;
      const enlace = `${urlToShare}${fileName}.pdf`;
      const codigo = dataCert.codigoCertificado;
      const enlaceQR = `${constantes.URL_CERTIFICATE}/ValidateCertificateQR?codigo=${dataCert.codigoCertificado}&tipo=2`;

      // Calcular detalle de notas
      let promedioNotaD = 0;
      const detalle = listaCursoPrograma.map((curso, index) => {
        const unidades = listaUnidadeCursoPrograma.filter(x => x.idCurso === curso.idCurso);
        let notaMasAlta = 0;

        unidades.forEach(unidad => {
          const evaluaciones = listaEvaluacionesUnidadeCursoPrograma.filter(
            x => x.idUnidad === unidad.idUnidad
          );
          if (evaluaciones.length > 0) {
            const notas = evaluaciones.map(e => e.nota);
            notaMasAlta += Math.max(...notas);
          }
        });

        const promedioCurso = unidades.length > 0 ? notaMasAlta / unidades.length : 0;
        promedioNotaD += promedioCurso;

        return {
          nombremodulo: curso.curso.nombre,
          promedio: promedioCurso.toFixed(0),
          orden: index + 1,
        };
      });

      const promedionota = (promedioNotaD / listaCursoPrograma.length).toFixed(0);
      const jsonData = JSON.stringify({
        nombrealumno,
        nombrecursoprograma,
        ubicacion,
        enlace,
        enlaceQR,
        codigo,
        promedionota,
        detalle,
      });

      const dataCDN = {
        Extension: enlace.split('.').pop(),
        NombreCDN: fileName
      };

      setspinnerNotas(true);
      setButtonDisabledNotas(true);

      const response = { link: enlace, fileName };
      await CertificadoFProgramaEspecializacionNotas({ jwt, jsonData, dataCDN, response });

      setButtonDisabledNotas(false);
      setspinnerNotas(false);
    } catch (error) {
      setspinnerNotas(false);
      toast.error("Error al generar el detalle de notas", { autoClose: 3000 });
      console.error("Error en handleDownloadNotasPrograma:", error);
    }
  }, [listaCursoPrograma, listaUnidadeCursoPrograma, listaEvaluacionesUnidadeCursoPrograma, Persona, programa, setspinnerNotas]);

  // ============================================
  // COMPUTED - Tooltip del certificado (como computed en Vue)
  // ============================================
  const tooltipCertificado = useMemo(() => {
    if (programaAprobado && !isButtonDisabledCertificado) return "";
    if (PersonaProgamaData?.idCondicion === 2 && PersonaProgamaData?.finPrograma != null) {
      return "Este botón se encuentra desactivado, dado que desaprobaste el programa.";
    }
    return "Este botón se encuentra desactivado, dado que aún no terminas el programa.";
  }, [programaAprobado, isButtonDisabledCertificado, PersonaProgamaData]);

  const tooltipNotas = useMemo(() => {
    if (programaAprobado && !isButtonDisabledNotas) return "";
    if (PersonaProgamaData?.idCondicion === 2 && PersonaProgamaData?.finPrograma != null) {
      return "Este botón se encuentra desactivado, dado que desaprobaste el programa.";
    }
    return "Este botón se encuentra desactivado, dado que aún no terminas el programa.";
  }, [programaAprobado, isButtonDisabledNotas, PersonaProgamaData]);

  // ============================================
  // TEMPLATE (RENDER)
  // ============================================
  return (
    <>
      <EncuastaPrograma
        idEncuestas={idEncuestas}
        mostrarEncuestas={mostrarEncuestas}
        programa={programa}
        listaCursoPrograma={listaCursoPrograma}
      />
      
      <div className="field col-12 md:col-7 card__contenedor__responsive" style={{ paddingRight: "1.2rem" }}>
        <div className="rounded-9 shadow card__bienvenida_responsive p-md-4 mb-2 md-4 cardTabs" style={{ minHeight: "64%" }}>
          <div className="row g-2 align-items-center">
            <div className="rounded-10 p-md-4 mb-md-4">
              <div className="p-fluid formgrid grid">
                <div className="field col-12 md:col-12 fontsizeinitial space_bottom">
                  <span className="h3 titulo_bienvenida_responsive" data-v-48f3e599="">
                    ¡Hola {Persona.nombres?.split(' ')[0]}!
                  </span>
                  <span className="description_bienvenida_responsive fontsizeinitial h3" data-v-48f3e599="">
                    Te damos la bienvenida al programa "{programa.nombre}"
                  </span>
                  <span className="avance_description_responsive">
                    {mensajeProgreso}
                  </span>
                </div>
              </div>
              <div className="barra__progreso__Responsive">
                <ProgressBar
                  value={ProgresoPrograma}
                  displayValueTemplate={() => <></>}
                  style={{ height: "8px", borderRadius: "0px" }}
                  color="#FFB62F"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="p-fluid formgrid grid progreso-desktop-flex">
          {/* Certificado */}
          <div className="col-35 md:col-6 mt-1">
            <div className="p-fluid formgrid grid">
              <div className="col-12 md:col-9" style={{ paddingRight: 0, height: "80px" }}>
                <div className="border rounded-9 shadow p-md-4 mb-md-4 cardTabsArchivos" style={{ height: "100%" }}>
                  <span className="subtitle text-sm h3" data-v-48f3e599="">
                    Certificado del programa
                  </span>
                </div>
              </div>
              <div className="col-12 md:col-3" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div
                  className={
                    programaAprobado && !isButtonDisabledCertificado
                      ? "flex align-items-center justify-content-center interna-material-download"
                      : "flex align-items-center justify-content-center interna-material-download-apagado botonesprograma-cert"
                  }
                  style={{ height: "80px" }}
                  onClick={() => programaAprobado && onDownloadCertificadoPrograma()}
                >
                  <Tooltip target=".botonesprograma-cert" content={tooltipCertificado} className="white-tooltip" />
                  {spinnerCertificado ? (
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                  ) : (
                    <img src={iconDownload} width="17.5px" height="21px" alt="Descargar Certificado" />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Notas */}
          <div className="col-35 md:col-6 mt-1" style={{ paddingRight: 0 }}>
            <div className="p-fluid formgrid grid">
              <div className="col-12 md:col-9" style={{ paddingRight: 0, height: "80px" }}>
                <div className="border rounded-9 shadow p-md-4 mb-md-4 cardTabsArchivos" style={{ height: "100%" }}>
                  <span className="text-sm h3" style={{ marginTop: "10px" }} data-v-48f3e599="">
                    Detalle de notas del programa
                  </span>
                </div>
              </div>
              <div className="col-12 md:col-3" style={{ paddingLeft: 0, height: "80px", paddingRight: 0 }}>
                <div
                  className={
                    programaAprobado && !isButtonDisabledNotas
                      ? "flex align-items-center justify-content-center interna-material-download"
                      : "flex align-items-center justify-content-center interna-material-download-apagado botonesprograma-notas"
                  }
                  style={{ height: "100%", display: "flex", justifyContent: "flex-end" }}
                  onClick={() => programaAprobado && handleDownloadNotasPrograma()}
                >
                  <Tooltip target=".botonesprograma-notas" content={tooltipNotas} className="white-tooltip" />
                  {spinnerNotas ? (
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                  ) : (
                    <img src={iconDownload} width="17.5px" height="21px" alt="Descargar Notas" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CardBienvenidaProgramaComponent;